import React, { useState } from 'react';
import { Edit2 } from 'lucide-react';
import ToolManagmentCard from '../../../../../common/element/Card/ToolManagmnetCard';
import AddEditCoach from '../AddEdit';
import ThreeDotBouncingLoader from '../../../../../common/element/ButtonLoader/ThreeDotBouncingLoder';

const CoachInfoCard = ({ coachData }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  // Guard: if coachData is not yet available, render a placeholder to avoid runtime errors
  if (!coachData) {
    return (
      <ToolManagmentCard>
        <div className="p-6 text-center text-gray-500"><ThreeDotBouncingLoader/></div>
      </ToolManagmentCard>
    );
  }

  // Normalize nested fields to simple strings
  const coachName =  (coachData.user && `${coachData.user.first_name} ${coachData.user.last_name}`) || coachData.display_name || '';
  const companyName = coachData.company_name || '';
  const displayName = coachData.display_name || '';
  const emailAddress = (coachData.user && coachData.user.email) || coachData.email || '';
  const phoneNumber2 = coachData.mobile_number || coachData?.work_phone ||'';
  const phoneLandline = coachData.phone_landline || '';
  const addressLines = coachData.address ? coachData.address.split('\n') : ['',''];
  const address1 = addressLines[0] || '';
  const address2 = addressLines[1] || '';
  const country = coachData.country?.country_name || (typeof coachData.country === 'string' ? coachData.country : '') || '';
  const state = coachData.state?.state_name || (typeof coachData.state === 'string' ? coachData.state : '') || '';
  const city = coachData.city?.city_name || (typeof coachData.city === 'string' ? coachData.city : '') || '';
  const pincode = coachData.pincode || '';
  const remark = coachData.remarks || coachData.remark || '';
  const documents = coachData.documents || [];
  // Prepare a mapped payload for AddEditCoach (it expects id and flat fields)
  const editPayload = {
    id: coachData.coach_id || coachData.id,
    coach_type: coachData.coach_type || '',
    title: coachData.title || '',
    first_name: coachData.user?.first_name || coachData.first_name || '',
    last_name: coachData.user?.last_name || coachData.last_name || '',
    company_name: coachData.company_name || '',
    display_name: coachData.display_name || displayName,
    email: coachData.user?.email || coachData.email || '',
    work_phone: coachData.work_phone || '',
    mobile_number: coachData?.user?.mobile_number || '',
    isPortalEnabled: coachData.isPortalEnabled || false,
    address: coachData.address || '',
    city: coachData.city?.city_id || coachData.city || 0,
    state: coachData.state?.state_id || coachData.state || 0,
    pincode: coachData.pincode || '',
    phone_landline: coachData.phone_landline || '',
    country: coachData.country?.country_id || coachData.country || 0,
    remarks: coachData.remarks || coachData.remark || '',
    documents: coachData.documents || []
  };

  return (
    <>
      <ToolManagmentCard>
        <div className="flex justify-between items-center py-4 border-b border-gray-200">
          <h2 className="font-lato font-semibold text-[16px] leading-[150%] text-[#101828] text-start">Coach Information</h2>
          <button className="px-[14px] py-2 bg-white border border-[#F2F4F7] hover:bg-[#f2f4f7] flex gap-1 items-center shadow-[0px_1px_2px_rgba(16,24,40,0.05)] rounded-lg" onClick={() => setDialogOpen(true)} >
            <span className="text-sm font-semibold font-lato">Edit</span>
            <Edit2 size={16} />
          </button>
        </div>

        {/* Information Grid */}
        <div className="py-6">
          <div className="grid grid-cols-3 gap-x-8 gap-y-4">
            {/* Row 1 */}
            {coachName &&  <div className='text-start'>
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">Coach name</label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">{coachName}</p>
            </div>}
           
            {companyName &&   <div className='text-start'>
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">Company name</label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">{companyName}</p>
            </div> }
          {displayName && <div className='text-start'>
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">Display name</label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">{displayName}</p>
            </div>}
            

            {/* Row 2 */}
            {emailAddress  &&  <div className='text-start'>
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">Email Address</label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">{emailAddress}</p>
            </div> }
           {phoneNumber2 &&   <div className='text-start'>
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">Phone number</label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">{phoneNumber2}</p>
            </div>}
          {phoneLandline && <div className='text-start'>
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">Phone Landline</label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">{phoneLandline}</p>
            </div>}
            

            {/* Row 3 */}
            { address1 &&  <div className='text-start'>
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">Address 1</label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">{address1}</p>
            </div>}
           {address2 &&  <div className='text-start'>
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">Address 2</label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">{address2}</p>
            </div> }
           

            {/* Row 4 */}
            {country &&  <div className='text-start'>
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">Country</label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">{country}</p>
            </div>}
           {state &&
            <div className='text-start'>
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">State</label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">{state}</p>
            </div>}
             {city &&
            <div className='text-start'>
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">City</label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">{city}</p>
            </div>}
            {pincode && 
            <div className='text-start'>
              <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">Pincode</label>
              <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">{pincode}</p>
            </div>}
          </div>

          {/* Remark Section */}
          {remark &&  <div className="mt-6 text-start">
            <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">Remark</label>
            <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">{remark}</p>
          </div>}
          {
            documents && documents.length > 0 && (
              <div className="mt-6 text-start">
                <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">Documents</label>
                <div className="mt-2 flex flex-col gap-3">
                  {documents.map((item, idx) => {
                    // Derive filename and extension
                    const fileName = item.document_name || (item.document_url && item.document_url.split('/').pop()) || `file-${idx + 1}`;
                    const ext = (fileName.split('.')?.pop() || '').toLowerCase();

                    // Map common extensions to icons stored in public/assets/icons-svg
                    const iconMap = {
                      pdf: '/assets/icons-svg/pdf.svg',
                      doc: '/assets/icons-svg/docs.svg',
                      docx: '/assets/icons-svg/docs.svg',
                      png: '/assets/icons-svg/png.svg',
                      jpg: '/assets/icons-svg/png.svg',
                      jpeg: '/assets/icons-svg/png.svg',
                      xlsx: '/assets/icons-svg/docs.svg',
                      default: '/assets/icons-svg/docs.svg'
                    };

                    const icon = iconMap[ext] || iconMap.default;

                    return (
                      <div key={item.id || idx} className="flex items-center gap-3 w-full max-w-md px-3 py-2 border border-gray-200 rounded-lg bg-white">
                        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#FFF7ED] flex items-center justify-center">
                          <img src={icon} alt={ext || 'file'} className="object-contain" />
                        </div>
                        <div className="min-w-0">
                          <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0 truncate">{fileName}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )
          }
         
        </div>
      </ToolManagmentCard>
      <AddEditCoach
        dialogOpen={dialogOpen}
        onDialogClose={() => setDialogOpen(false)}
        coachData={editPayload}
      />

    </>
  );
};

export default CoachInfoCard;